export const SERVICES = [
  { key: "website",    code: "W-01", name: "Websites",           blurb: "Marketing sites, product pages, landing systems." },
  { key: "crm",        code: "C-02", name: "CRM Platforms",      blurb: "Custom pipelines, contact intelligence, ops." },
  { key: "booking",    code: "B-03", name: "Booking Systems",    blurb: "Calendars, reminders, availability, and optional payment workflows." },
  { key: "chatbot",    code: "N-04", name: "AI Chatbots",        blurb: "Domain-trained assistants for sales & support." },
  { key: "automation", code: "A-05", name: "Automation",         blurb: "Cross-app workflows that eliminate busywork." },
  { key: "workflow",   code: "I-06", name: "Internal Workflows", blurb: "Internal tools tuned to your team's ops." },
];

export const SERVICE_BY_KEY = Object.fromEntries(SERVICES.map(s => [s.key, s]));
